"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _link = _interopRequireDefault(require("../../core/link"));
var _ms = _interopRequireDefault(require("ms"));
var _table = _interopRequireDefault(require("../../core/table"));
var _createClubForm = _interopRequireDefault(require("./create-club-form"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function timeAgo(time) {
  return time ? (0, _ms.default)(Math.max(Date.now() - new Date(time).getTime(), 0), {
    long: true
  }) : 'unknown';
}
var _ref = /*#__PURE__*/_react.default.createElement("h2", null, "Clubs");
var _ref2 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Name"), /*#__PURE__*/_react.default.createElement("th", null, "Treasurer"), /*#__PURE__*/_react.default.createElement("th", null, "Status"), /*#__PURE__*/_react.default.createElement("th", null, "Competitions This Year")));
var _ref3 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-success"
}, "Stripe is setup, ready to take entries");
var _ref4 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-info"
}, "Stripe is setup, waiting for stripe's verification");
var _ref5 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-warning"
}, "Stripe is setup, but verification has failed");
var _ref6 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-info"
}, "Ready to send instructions to treasurer");
var _ref7 = /*#__PURE__*/_react.default.createElement("span", {
  className: "text-info"
}, "Waiting for initiator");
class ClubsList extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_createClubForm.default, {
      onCreateClub: this.props.onCreateClub
    }), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref2, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.clubs.map(club => /*#__PURE__*/_react.default.createElement("tr", {
      key: club.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_link.default, {
      to: '/settings/clubs/' + club.id
    }, club.clubName)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("a", {
      href: 'mailto:' + club.treasurerEmail
    }, club.treasurerName)), /*#__PURE__*/_react.default.createElement("td", null, club.hasStripeSetup ? club.verificationStatus.status === 'verified' ? _ref3 : club.verificationStatus.status === 'pending' ? _ref4 : _ref5 : club.hasBankDetailsHash ? club.treasurerEmailSent ? /*#__PURE__*/_react.default.createElement("span", {
      className: "text-info"
    }, "Waiting for treasurer to setup. Email sent ", timeAgo(club.treasurerEmailSent), " ago.") : _ref6 : _ref7), /*#__PURE__*/_react.default.createElement("td", null, club.competitionsByYear.map(comp => /*#__PURE__*/_react.default.createElement("p", {
      key: comp.id,
      style: {
        marginBottom: 0
      }
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      to: '/year/' + comp.yearID + '/competition/' + comp.competitionSlug + '/set-up'
    }, comp.competitionName)))), /*#__PURE__*/_react.default.createElement("td", null, club.verificationStatus && club.verificationStatus.capabilities.join('; ')))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref8 = {
  clubs: {
    id: true,
    clubName: true,
    treasurerEmail: true,
    treasurerName: true,
    hasStripeSetup: true,
    hasBankDetailsHash: true,
    treasurerEmailSent: true,
    verificationStatus: true,
    ["competitionsByYear(yearID:" + JSON.stringify(null) + ")"]: {
      id: true,
      competitionName: true,
      competitionSlug: true,
      yearID: true
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(ClubsList, props => _ref8, (client, props) => ({
  onCreateClub(club) {
    return client.update('Club.create', club);
  }
}));